import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { addParamsToUrl } from 'utils/query';
import { Resource, BaseResponse } from 'types';
import { providesList, cacheByIdArg } from 'utils/query-cache';

import { apiQuery } from '../../query';

import { ResourceListRequest, ResourceListResponse } from './types';

const tagType = 'RESOURCES' as const;

export const resourcesApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'resourcesApi',
  endpoints: (build) => ({
    details: build.query<Resource, string>({
      providesTags: cacheByIdArg(tagType),
      transformResponse: (response: BaseResponse<Resource>) => response.data,
      query: (id) => ({
        method: 'get',
        url: URL.LIBRARY_RESOURCE_DETAILS.replace(':id', id),
      }),
    }),
    list: build.query<ResourceListResponse, ResourceListRequest>({
      providesTags: providesList(tagType),
      transformResponse: (response: BaseResponse<ResourceListResponse>) =>
        response.data,
      query: (params) => ({
        method: 'get',
        url: addParamsToUrl(URL.LIBRARY_RESOURCES, params),
      }),
    }),
  }),
});

export const { useListQuery, useDetailsQuery } = resourcesApi;

export type { ResourceListRequest, ResourceListResponse };
